import { useContext, useEffect, useState } from 'react'
import { AuthContextApi } from '../../Context/api'
import Header from '../../Components/Header'
import {
    CheckCircleIcon,
    EnvelopeIcon,
    KeyIcon,
    UserIcon,
    ExclamationTriangleIcon,
    CheckIcon
} from '@heroicons/react/24/outline'
import moment from 'moment'

const Perfil = () => {

    const { checkLogin,
        profileChangeEmail,
        profileChangeSenha } = useContext(AuthContextApi)
    const [emailUsuario, setEmailUsuario] = useState('')
    const [cumprimento, setCumprimento] = useState('')
    const [trocarSenha, setTrocarSenha] = useState(true)

    const [email, setEmail] = useState('')
    const [senha, setSenha] = useState('')
    const [novaSenha, setNovaSenha] = useState('')
    const [confirmarSenha, setConfirmarSenha] = useState('')
    const [errorEmail, setErrorEmail] = useState(false)
    const [errorEmailMessage, setErrorEmailMessage] = useState('Campo obrigatório')
    const [errorSenha, setErrorSenha] = useState(false)
    const [errorSenhaMensagem, setErrorSenhaMensagem] = useState('Campo obrigatório')
    const [errorNovaSenha, setErrorNovaSenha] = useState(false)
    const [errorConfirmarSenha, setErrorConfirmarSenha] = useState(false)





    const primeiroLoad = async () => {
        await checkLogin()
    }


    const getGreeting = () => {
        const hour = moment().hour()
        if (hour < 12) {
            setCumprimento('Bom dia')
        } else if (hour < 18) {
            setCumprimento('Boa tarde')
        } else {
            setCumprimento('Boa noite')
        }
    }


    const actionButton = async (modo) => {
        let error = false


        if (senha === '') {
            setErrorSenha(true)
            setErrorSenhaMensagem('Campo obrigatório')
            error = true
        } else setErrorSenha(false)

        let obj = {}
        if (modo === 'senha') {
            if (novaSenha === '') {
                setErrorNovaSenha(true)
                error = true
            } else setErrorNovaSenha(false)

            if (confirmarSenha === '') {
                setErrorConfirmarSenha(true)
                error = true
            } else setErrorConfirmarSenha(false)

            if (novaSenha !== confirmarSenha) {
                setErrorNovaSenha(true)
                setErrorSenhaMensagem('As senhas não coincidem')
                error = true
            } else {
                setErrorNovaSenha(false)
                setErrorSenhaMensagem('Campo obrigatório')
            }
            const isStrongerPassword = novaSenha.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).{8,}$/)
            if (!isStrongerPassword) {
                setErrorNovaSenha(true)
                setErrorSenhaMensagem('A senha deve conter no mínimo 8 caracteres, uma letra maiúscula e um número')
                error = true
            } else {
                setErrorNovaSenha(false)
                setErrorSenhaMensagem('Campo obrigatório')
            }
            obj = {
                senha: senha,
                novaSenha
            }
        } else {
            if (email === '') {
                setErrorEmail(true)
                setErrorEmailMessage('Campo obrigatório')
                error = true
            } else setErrorEmail(false)

            const getMailStorage = localStorage.getItem('usuario')
            if (email === getMailStorage) {
                setErrorEmail(true)
                setErrorEmailMessage('O e-mail não pode ser igual ao atual')
                error = true
            } else {
                setErrorEmail(false)
                setErrorEmailMessage('Campo obrigatório')
            }
            obj = {
                email: email,
                senha: senha
            }

        }
        if (error) {
            error = false
            return
        }

        if (modo === 'senha') {
            const resp = await profileChangeSenha(obj)
            if (resp.status === false) {
                setErrorSenha(true)
            } else {
                setErrorSenha(false)
                setSenha('')
                setNovaSenha('')
                setConfirmarSenha('')
                setErrorSenhaMensagem('Campo obrigatório')
            }
        } else {
            const resp = await profileChangeEmail(obj)
            if (resp.status === false) {
                setErrorEmail(true)
            } else {
                setErrorEmail(false)
                setEmail('')
                setSenha('')
                setErrorEmailMessage('Campo obrigatório')
            }
        }

    }


    useEffect(() => {
        primeiroLoad()
        getGreeting()
        setEmailUsuario(localStorage.getItem('usuario'))
    }, [])

    useEffect(() => {
        setErrorConfirmarSenha(false)
        setErrorEmail(false)
        setErrorNovaSenha(false)
        setErrorSenha(false)
        if (trocarSenha) {
            setEmail(localStorage.getItem('usuario'))
            setSenha('')
            setNovaSenha('')
            setConfirmarSenha('')
        } else {
            setEmail('')
            setSenha('')
            setNovaSenha('')
            setConfirmarSenha('')

        }
    }, [trocarSenha])


    const inputClass = (hasError) =>
        `w-full px-4 py-2.5 border rounded-xl text-sm transition-all focus:outline-none focus:ring-2 ${hasError
            ? 'border-red-300 bg-red-50 focus:ring-red-400'
            : 'border-gray-200 bg-white focus:ring-brand-yellow focus:border-brand-yellow'
        }`

    const ErrorText = ({ show, message }) => show && (
        <div className="mt-2 flex items-center gap-2 text-red-600">
            <ExclamationTriangleIcon className="w-4 h-4" />
            <span className="text-sm">{message}</span>
        </div>
    )

    return (
        <>
            <Header
                title="Meu Perfil"
                description="Gerencie suas informações pessoais"
                icon={UserIcon}
                hasAction={false}
                hasReturn={false}
            />

            <div className="px-6 pt-5 pb-6 space-y-6">
                <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
                    <div className="flex items-center gap-3">
                        <div className="p-2 rounded-xl bg-gray-900">
                            <CheckCircleIcon className="w-5 h-5 text-brand-yellow" />
                        </div>
                        <div>
                            <h2 className="text-base font-semibold text-gray-900">{cumprimento}, {emailUsuario}</h2>
                            <p className="text-sm text-gray-400">Sua conta está ativa e protegida.</p>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-2xl p-2 border border-gray-100 shadow-sm w-full sm:w-fit">
                    <div className="flex">
                        <button
                            type="button"
                            className={`px-5 py-2.5 rounded-xl text-sm font-semibold transition-all ${trocarSenha ? 'bg-gray-900 text-brand-yellow shadow-sm' : 'text-gray-600 hover:bg-gray-50'}`}
                            onClick={() => setTrocarSenha(true)}
                        >
                            Alterar Senha
                        </button>
                        <button
                            type="button"
                            className={`px-5 py-2.5 rounded-xl text-sm font-semibold transition-all ${!trocarSenha ? 'bg-gray-900 text-brand-yellow shadow-sm' : 'text-gray-600 hover:bg-gray-50'}`}
                            onClick={() => setTrocarSenha(false)}
                        >
                            Alterar E-mail
                        </button>
                    </div>
                </div>

                {!trocarSenha && (
                    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
                        <div className="px-6 py-4 border-b border-gray-100 flex items-center gap-2">
                            <div className="p-1.5 bg-gray-900 rounded-lg">
                                <EnvelopeIcon className="w-4 h-4 text-brand-yellow" />
                            </div>
                            <h3 className="text-sm font-semibold text-gray-900">Alterar E-mail</h3>
                        </div>

                        <div className="p-6 space-y-4">
                            <div className="bg-gray-50 rounded-xl p-4 border border-gray-100">
                                <label className="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1">E-mail atual</label>
                                <p className="text-sm text-gray-900 font-medium">{emailUsuario}</p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1.5">Novo E-mail *</label>
                                <input
                                    type="email"
                                    className={inputClass(errorEmail)}
                                    placeholder="Digite seu novo e-mail"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <ErrorText show={errorEmail} message={errorEmailMessage} />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1.5">Senha Atual *</label>
                                <input
                                    type="password"
                                    className={inputClass(errorSenha)}
                                    placeholder="Digite sua senha atual para confirmar"
                                    value={senha}
                                    onChange={(e) => setSenha(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && actionButton('email')}
                                />
                                <ErrorText show={errorSenha} message={errorSenhaMensagem} />
                            </div>

                            <div className="flex justify-end">
                                <button
                                    onClick={() => actionButton('email')}
                                    className="px-5 py-2.5 bg-brand-yellow hover:bg-brand-yellow-dark text-gray-900 rounded-xl font-semibold transition-all hover:scale-105"
                                >
                                    Alterar E-mail
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {trocarSenha && (
                    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
                        <div className="px-6 py-4 border-b border-gray-100 flex items-center gap-2">
                            <div className="p-1.5 bg-gray-900 rounded-lg">
                                <KeyIcon className="w-4 h-4 text-brand-yellow" />
                            </div>
                            <h3 className="text-sm font-semibold text-gray-900">Alterar Senha</h3>
                        </div>

                        <div className="p-6 space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1.5">Senha Atual *</label>
                                <input
                                    type="password"
                                    className={inputClass(errorSenha)}
                                    placeholder="Digite sua senha atual"
                                    value={senha}
                                    onChange={(e) => setSenha(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && actionButton('senha')}
                                />
                                <ErrorText show={errorSenha} message={errorSenhaMensagem} />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1.5">Nova Senha *</label>
                                <input
                                    type="password"
                                    className={inputClass(errorNovaSenha)}
                                    placeholder="Digite sua nova senha"
                                    value={novaSenha}
                                    onChange={(e) => setNovaSenha(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && actionButton('senha')}
                                />
                                <ErrorText show={errorNovaSenha} message={errorSenhaMensagem} />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1.5">Confirmar Nova Senha *</label>
                                <input
                                    type="password"
                                    className={inputClass(errorConfirmarSenha)}
                                    placeholder="Confirme sua nova senha"
                                    value={confirmarSenha}
                                    onChange={(e) => setConfirmarSenha(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && actionButton('senha')}
                                />
                                <ErrorText show={errorConfirmarSenha} message="Campo obrigatório" />
                            </div>

                            <div className="bg-gray-50 border border-gray-100 rounded-xl p-4">
                                <h4 className="text-sm font-semibold text-gray-700 mb-2">Requisitos da senha</h4>
                                <ul className="text-sm text-gray-500 space-y-1">
                                    <li className="flex items-center gap-2"><CheckIcon className="w-4 h-4 text-brand-yellow" /><span>Mínimo 8 caracteres</span></li>
                                    <li className="flex items-center gap-2"><CheckIcon className="w-4 h-4 text-brand-yellow" /><span>Pelo menos uma letra maiúscula</span></li>
                                    <li className="flex items-center gap-2"><CheckIcon className="w-4 h-4 text-brand-yellow" /><span>Pelo menos um número</span></li>
                                    <li className="flex items-center gap-2"><CheckIcon className="w-4 h-4 text-brand-yellow" /><span>Pelo menos um caractere especial (@$!%*?&)</span></li>
                                </ul>
                            </div>

                            <div className="flex justify-end">
                                <button
                                    onClick={() => actionButton('senha')}
                                    className="px-5 py-2.5 bg-brand-yellow hover:bg-brand-yellow-dark text-gray-900 rounded-xl font-semibold transition-all hover:scale-105"
                                >
                                    Alterar Senha
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    )

}



export default Perfil